import type { HeaderCarousel } from 'types/capi/modules';

import destinationPath from '~/utils/destinationPath';

import ImpressionEvent, { type ImpressionType } from './ImpressionEvent';
import type { SplashSlideModuleType } from './SplashSlideInteractionEvent';

export type SplashSlideImpressionProperties = {
  destination_path?: string;
  destination_url?: string;
  heading?: string;
  image_url: string;
  module_position?: number;
  module_type: SplashSlideModuleType;
  position: number;
  retailer_id?: string;
};

type EventData = {
  guestId?: string;
  isBot: boolean;
  modulePosition?: number;
  moduleType: SplashSlideModuleType;
  position: number;
  slide: HeaderCarousel['items'][0];
};

// The seen-side of SplashSlideInteractionEvent, on the same keys so a slide's impressions and
// clicks join. A slide with no CTA still emits: it was seen, and it is the denominator its clicks
// are read against. No clickref - that is minted for a click-out and rides on the click.
class SplashSlideImpressionEvent extends ImpressionEvent<
  EventData,
  SplashSlideImpressionProperties
> {
  protected get impressionType(): ImpressionType {
    return 'splash_slide';
  }

  protected getImpressionProperties(): SplashSlideImpressionProperties {
    const { modulePosition, moduleType, position, slide } = this.data;
    const { cta } = slide;

    return {
      destination_path:
        cta?.type === 'internal' ? destinationPath(cta.path) : undefined,
      destination_url: cta?.type === 'external' ? cta.url : undefined,
      heading: slide.heading || undefined,
      image_url: slide.images.mobile?.url || slide.images.desktop.url,
      module_position: modulePosition,
      module_type: moduleType,
      position,
      retailer_id:
        cta?.type === 'external'
          ? cta.affiliate?.canonical_id || undefined
          : undefined
    };
  }
}

export default SplashSlideImpressionEvent;
